module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ../~/axios/index.js
// module id = 323
// module chunks = 0